<app-modal-container
  [formGroup]="form"
  [applyActivated]="form.valid"
  (closeButtonClicked)="closeEmitter.emit(false)"
  (dismissButtonClicked)="closeEmitter.emit(false)"
  [buttons]="modalButtons"
  [title]="'Permissions in bulk'"
  (applyButtonClicked)="showModalDialog = true">
  <div class="centered-column-container column-gap-0p5 width-20">
    <app-selector
      [attr.data-qa]="'kpi-msl-bulk-request-role'"
      class="width-15"
      [isNotInTable]="true"
      [formControl]="form.controls.role"
      [data]="MetricDataRoleMap"
    />
    <app-selector
      [attr.data-qa]="'kpi-msl-bulk-request-from'"
      class="width-15"
      [title]="'From'"
      [isNotInTable]="true"
      [formControl]="form.controls.from"
      [overlayContentClass]="['overlay-pop-up', '!max-h-[20rem]']"
      [data]="periods.from"
    />
    <app-selector
      [attr.data-qa]="'kpi-msl-bulk-request-till'"
      class="width-15"
      [title]="'Till'"
      [isNotInTable]="true"
      [formControl]="form.controls.till"
      [overlayContentClass]="['overlay-pop-up', '!max-h-[20rem]']"
      [data]="periods.till"
    />
  </div>
</app-modal-container>

@if (showModalDialog){
  <app-modal-container
    [title]="title"
    [innerModal]="true"
    [buttons]="{close: true}"
    (closeButtonClicked)="closeEmitter.emit(false)">
    <div class="flex flex-col items-center content-center justify-between min-w-[27.03125rem] min-h-[21.40625rem]">
      <div class="mt-auto mb-auto flex flex-col items-center content-center gap-4">
        <app-all-icons [iconNameAndStyling]="'empty-exclamation.svg;icon-size-3'"/>
        <div data-qa="kpi-modal-bulk-msl-text" class="flex flex-col items-center content-center font-2 font-semibold">
          <span>Periods from {{form.value.from}} to {{form.value.till}} will</span>
          <span>be requested from {{numberOfCompaniesMslWillBeApplied}} companies</span>
        </div>
      </div>
      <div class="flex flex-row items-center content-center gap-2">
        <app-button
          data-qa="kpi-modal-bulk-msl-cancel-button"
          [size]="'small'"
          (buttonClick)="closeEmitter.emit(false)">
          Cancel
        </app-button>
        <app-button
          data-qa="kpi-modal-bulk-msl-apply-button"
          [type]="'accent'"
          [size]="'small'"
          (buttonClick)="apply()">
          Apply
        </app-button>
      </div>
    </div>
  </app-modal-container>
}
